import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Batch 2 §12 — Worker frontage via api.jjargent.com (custom domain).
// Set REACT_APP_WORKER_API in frontend/.env; falls back to the custom domain.
const WORKER_API = process.env.REACT_APP_WORKER_API || "https://api.jjargent.com/api";

// Silent page-tracking hook — fires POST /api/track on every route change.
// Ignores /admin/*. Includes query string so A/B variant tags survive.
export function usePageTracking() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    fetch(`${WORKER_API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page: `${pathname}${search || ""}` }),
      keepalive: true,
    }).catch(() => { /* silent */ });
  }, [pathname, search]);
}
